module.exports = __webpack_public_path__ + "img/ceshi.8a714c22.jpg";